import React from 'react';
export function SocialProofSection() {
  const testimonials = [{
    initials: 'EP',
    quote: "I used to take loads of photos and still keep almost none. Now I actually know what I'm doing.",
    attribution: '— Emily P. | Dog Mom — Auckland, New Zealand'
  }, {
    initials: 'LR',
    quote: 'My dog finally looks in photos the way she feels in real life. That alone made this worth it.',
    attribution: '— Liam R. | Dog Owner — Wellington, New Zealand'
  }, {
    initials: 'SC',
    quote: 'The tips are simple, practical, and easy to apply with a phone. Massive difference straight away.',
    attribution: '— Sophie C. | Dog Lover — Christchurch, New Zealand'
  }];
  const painPoints = ['You take lots of photos, but very few actually feel special', 'Your dog moves before you get the shot you wanted', 'Indoor photos come out dark, flat, or disappointing', 'Outdoor photos look random, messy, or badly framed', "You know your dog is adorable… but your photos don't show it"];
  return <section className="bg-warm-mid py-16 md:py-24 px-4" data-id="element-322">
      <div className="max-w-5xl mx-auto" data-id="element-323">
        {/* SECTION 1: Stats Row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 mb-16 md:mb-20" data-id="element-324">
          <div className="text-center" data-id="element-325">
            <p className="font-serif text-4xl md:text-5xl font-bold text-warm-hero mb-2" data-id="element-326">
              +5,000
            </p>
            <p className="font-sans text-sm md:text-base font-medium text-dark-gold" data-id="element-327">
              dog lovers reached
            </p>
          </div>
          <div className="text-center" data-id="element-328">
            <p className="font-serif text-4xl md:text-5xl font-bold text-warm-hero mb-2" data-id="element-329">
              6
            </p>
            <p className="font-sans text-sm md:text-base font-medium text-dark-gold" data-id="element-330">
              complete books
            </p>
          </div>
          <div className="text-center" data-id="element-331">
            <p className="font-serif text-4xl md:text-5xl font-bold text-warm-hero mb-2" data-id="element-332">
              4.9/5
            </p>
            <p className="font-sans text-sm md:text-base font-medium text-dark-gold" data-id="element-333">
              average rating ★
            </p>
          </div>
          <div className="text-center flex flex-col items-center justify-center" data-id="element-334">
            <p className="text-4xl md:text-5xl mb-2 leading-none" data-id="element-335">🌍</p>
            <p className="font-sans text-sm md:text-base font-medium text-dark-gold max-w-[180px] mx-auto leading-snug" data-id="element-336">
              Created for English-speaking dog owners everywhere
            </p>
          </div>
        </div>

        {/* SECTION 2: Testimonial Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-20 md:mb-28" data-id="element-337">
          {testimonials.map((t, index) => <div key={index} className="bg-white border border-soft-gold/15 rounded-xl p-5 md:p-6 flex flex-col shadow-sm" data-id="element-338">
              <div className="flex items-start gap-4 mb-3" data-id="element-339">
                <div className="w-10 h-10 rounded-full bg-soft-gold/20 text-dark-gold flex items-center justify-center font-bold font-sans flex-shrink-0 text-sm" data-id="element-340">
                  {t.initials}
                </div>
                <div data-id="element-341">
                  <div className="flex text-orange text-sm mb-1" data-id="element-342">★★★★★</div>
                </div>
              </div>
              <p className="font-sans text-[15px] md:text-base text-gray-800 font-medium leading-relaxed mb-4 flex-grow" data-id="element-343">
                "{t.quote}"
              </p>
              <p className="font-sans text-xs text-gray-500" data-id="element-344">{t.attribution}</p>
            </div>)}
        </div>
      </div>
    </section>;
}